<template>
	<div class="fd-widgets" v-if="visible" :class="clazz" :style="style">
		<component v-for="(wg) in wgs.items" :is="componentOfPart(wg)" :part="partRef(wg)" :data="localData" :readonly="ro" :viewmode="vm" :inside-widgets="true"></component>
	</div>
</template>

<script setup lang="ts">
import useContainer, {type ContainerProps, containerProps} from "./Container";
import type {Widgets} from "@t/fd/layout/Widgets";
import {computed} from "vue";

const uprops = defineProps({...containerProps});
const props = uprops as ContainerProps;

const wgs = computed<Widgets>(() => props.part as Widgets);
const {visible, componentOfPart, partRef, localData, ro, vm, clazz, style} = useContainer(props);

</script>

<style>
.fd-widgets {
	margin: 0;
	display: grid;
	align-items: start;
	grid-template-columns: [wstart labelstart fieldstart] 1fr [labelend fieldend wend];
	row-gap: calc(2 * var(--form-v-padding));
	column-gap: calc(2 * var(--form-h-padding));
	--widget-start: 1;
	--widget-end: 2;
	--label-start: 1;
	--label-end: 2;
	--field-start: 1;
	--field-end: 2;
}

@container (width > 430px) {
	.fd-widgets {
		grid-template-columns: [wstart labelstart] auto [ labelend fieldstart]  minmax(150px, 1fr) [fieldend wend];
		--widget-start: 1;
		--widget-end: 3;
		--label-start: 1;
		--label-end: 2;
		--field-start: 2;
		--field-end: 3;
	}
}
</style>
